import { WeatherCondition } from '../../api/apiTypes'

/**
 * Convert a numeric weather condition from the API to the WeatherCondition enum.
 * The API stores weather condition as a number (0=Unknown, 1=Dry, 2=Wet, 3=Damp).
 */
export function toWeatherCondition(conditionValue?: number): WeatherCondition {
  switch (conditionValue) {
    case 1:
      return WeatherCondition.Dry
    case 2:
      return WeatherCondition.Wet
    case 3:
      return WeatherCondition.Damp
    default:
      return WeatherCondition.Dry
  }
}

/**
 * Get human-readable label for a weather condition.
 * Platform-agnostic — use in both mobile and web.
 */
export function getWeatherLabel(condition: WeatherCondition): string {
  switch (condition) {
    case WeatherCondition.Dry:
      return 'Dry'
    case WeatherCondition.Wet:
      return 'Wet'
    case WeatherCondition.Damp:
      return 'Damp'
    default:
      return 'Unknown'
  }
}

/**
 * Get a hex color associated with a weather condition.
 * Consistent across platforms for data visualization.
 */
export function getWeatherColor(condition: WeatherCondition): string {
  switch (condition) {
    case WeatherCondition.Dry:
      return '#F59E0B'
    case WeatherCondition.Wet:
      return '#3B82F6'
    case WeatherCondition.Damp:
      return '#6B7280'
    default:
      return '#6B7280'
  }
}
